// extracted by mini-css-extract-plugin
export default {"btn":"ThemeToggle_btn__KxMvQ","dark":"ThemeToggle_dark__ILdqO"};